import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Layout, Menu, Dropdown } from 'antd';
import { SidebarIcon } from '../../.././core/utils/general';
import { subRoutes, subDivisions, platformOnlyFeatures } from '../../.././core/utils/constants/constants';
import OrgDisplay from '../.././shared/OrgDisplay';
import sitemap from '../../routes/sitemap';
import {
  logo,
  subMenu,
  itemNotSelected,
  spanNotSelected,
  blackSpanNotSelected,
} from '../../shared/globalStyling/style';
import { determineUserAccess } from '../../../core/permissions/userLevelAccess';
import { getEffectivePermission } from '../../../core/permissions/effectivePermission';
//import ChatwootWidget from "../../../core/shared/ChatwootWidget";
//import { determineUserAccess } from "../../../core/permissions/userLevelAccess";
const { Sider } = Layout;
const { Item, SubMenu, ItemGroup } = Menu;

const getSpanStyle = (sidebarColor) => {
  if (!sidebarColor) return spanNotSelected;

  let cleanedColor = sidebarColor.startsWith('#') ? sidebarColor.slice(1) : sidebarColor;
  let [r, g, b] = cleanedColor.match(/.{1,2}/g).map((hex) => parseInt(hex, 16));
  const isWhite = r >= 200 && g >= 200 && b >= 200;

  return isWhite ? blackSpanNotSelected : spanNotSelected;
};

const shouldShowSubCategory = (features, subDivisions) => {
  const existsInArray = (el, arr) => arr.includes(el);
  return features.some((feature) => existsInArray(feature, subDivisions));
};

// MD-11242: The MAIN division always renders (it is not gated at the division level like
// ATTENTION SIGNALS / LIBRARY / TASK MANAGEMENT), so its child features must be gated on
// the user's own feature access. In horizontal navigation the widget previously listed
// PAID_SEARCH / SEO / DEMOGRAPHIC even when those features were toggled off. This mirrors
// the vertical nav's accessibleFeatures filter (hasAccessAll=false).
export const getVisibleMainFeatures = (mainFeatures, features) =>
  (mainFeatures || []).filter((feature) => (features || []).includes(feature));

const renderItemGroup = (key, title, items) => {
  if (!items.some(Boolean)) return null;
  return (
    <ItemGroup key={key} title={title} style={{ width: '100%', marginBottom: '10%' }}>
      {items}
    </ItemGroup>
  );
};

const transformURL = (url, feature) => {
  if (url !== undefined && url !== -1) return url;

  // The switch case is intentional in anticipation that there will be more features to be renamed.
  // If in the future, there are more features to be renamed, we can add more cases here.
  switch (feature) {
    case 'DEMOGRAPHIC':
      return '/demograph';
    case 'TASKS':
      return '/tasks/main/1';
    case 'CREATE_TASK':
      return '/tasks/form';
    case 'PROJECTS':
      return '/tasks/projects';
    case 'TASK_ANALYTICS':
      return '/tasks/analytics';
    case 'SYSTEM_ALERTS':
      return '/system-alerts';
    case 'INVOICES':
      return '/invoice';
    case 'API_DOCS':
      return '/api_docs';
    default:
      return `/${feature.toLowerCase()}`;
  }
};

const transformFeatureName = (feature) => {
  switch (feature) {
    case 'DEMOGRAPHIC':
      return ' Demograph';
    case 'AUDIENCES':
      return ' Audiences';
    case 'LOCATIONS':
      return ' Locations';
    case 'ADVERTISER':
      return ' Advertiser';
    case 'PUBLISHER':
      return ' Publisher';
    case 'SIGNAL TAGS':
      return ' Signal Tags';
    case 'INVOICES':
      return ' Invoices';
    case 'AUDIENCE':
      return ' Audience';
    case 'TARGETING':
      return ' Targeting';
    case 'TAGS':
      return ' Tags';
    case 'CREATIVES':
      return ' Creatives';
    case 'RETAILS_STORES':
      return ' Retail Stores';
    case 'SETTINGS':
      return ' Settings';
    case 'KNOWLEDGE_BASE':
      return ' Knowledge Base';
    case 'API_DOCS':
      return ' API Docs';
    case 'ORGS':
      return ' Organization';
    case 'TASKS':
      return ' Tasks';
    case 'CREATE_TASK':
      return ' Create Task';
    case 'PROJECTS':
      return ' Projects';
    case 'TASK_ANALYTICS':
      return ' Analytics';
    case 'SEO':
      return ' Seo Domains';
    case 'SYSTEM_ALERTS':
      return ' System Alerts';
    default:
      return feature;
  }
};

const accessibleFeatures = (
  allFeatures,
  features,
  rootPath,
  collapsed,
  subMenuSelected,
  setSubMenuSelected,
  sidebarColor,
  hasAccessAll = false, //Special Condition to show all feature without checking if user has access
  orgLevel,
  urlLink,
  parentOrgLevel,
  billing,
  // Preview-aware billing used ONLY for the Usage sub-route: in work-as-parent
  // mode the REAL user's permission applies; faithful preview keeps the
  // previewed org's flags. Defaults to billing so other callers are unchanged.
  usageBilling = billing
) => {
  return allFeatures
    .filter((feature) => {
      if (hasAccessAll) return true;
      return features.indexOf(feature) > -1;
    })
    .map((feature, i) => {
      if (
        (feature === 'INVOICES' && !billing) ||
        feature === 'LIBRARY' ||
        feature === 'HOME' ||
        feature === 'USERS' ||
        (platformOnlyFeatures.includes(feature) && orgLevel !== 'PLATFORM')
      ) {
        return null;
      }
      const selected =
        feature === rootPath && feature === 'CREATE_TASK' ? 'ant-menu-item-selected' : null;
      const keySubRoutes = Object.keys(subRoutes).find((key) => key === feature);
      const featureName =
        feature.replace(/_/g, ' ').charAt(0) + feature.replace(/_/g, ' ').slice(1).toLowerCase();
      const siteMapIndex = Object.values(sitemap).findIndex((sitemapValues) => {
        return sitemapValues === featureName;
      });

      const siteMapURL = Object.keys(sitemap)[siteMapIndex];
      return (
        <React.Fragment key={i}>
          {keySubRoutes ? (
            <SubMenu
              key={`${i}-submenu-${feature}`}
              onTitleClick={() => setSubMenuSelected(true)}
              popupClassName="vertical-sidebar-submenu"
              title={
                <span>
                  {collapsed ? (
                    <Link
                      style={{ color: 'rgba(255, 255, 255, 0.65)' }}
                      to={'/' + feature.toLowerCase()}
                    >
                      <SidebarIcon type={feature} />
                    </Link>
                  ) : (
                    <>
                      <Link style={subMenu} to={'/' + feature.toLowerCase()}>
                        <SidebarIcon type={feature} />
                        <span>
                          {feature === 'CAMPAIGNS'
                            ? 'Display'
                            : feature.replace(/_/g, ' ').charAt(0) +
                              feature.replace(/_/g, ' ').slice(1).toLowerCase()}
                        </span>
                      </Link>
                    </>
                  )}
                </span>
              }
            >
              {subRoutes[keySubRoutes].map((subRoute) => {
                const sitemapSubRouteIndex = Object.values(sitemap).findIndex(
                  (sitemapValues) => sitemapValues === subRoute
                );
                const subRouteURL = Object.keys(sitemap)[sitemapSubRouteIndex];
                let subName = subRoute;
                switch (subRoute) {
                  case 'Paid Search Campaign':
                    subName = 'Campaign';
                    break;
                  case 'SEO Domains':
                    subName = 'Domains';
                    break;
                  case 'Paid Search Reports':
                    subName = 'Reports';
                    break;
                  case 'SEO Reports':
                    subName = 'Reports';
                    break;
                  default:
                }
                if (orgLevel === 'STANDARD' && subRoute === 'Overview') return null;
                if (subRoute === 'Usage' && !usageBilling) return null;

                return (
                  <Item key={subRoute}>
                    <Link to={subRouteURL ? subRouteURL : '/home'}>
                      <span>{subName}</span>
                    </Link>
                  </Item>
                );
              })}
            </SubMenu>
          ) : (
            <Item
              key={feature}
              style={!subMenuSelected ? {} : itemNotSelected}
              className={selected}
              onClick={() => setSubMenuSelected(false)}
            >
              <Link
                to={transformURL(siteMapURL, feature)}
                onClick={() => {
                  if (transformURL(siteMapURL, feature) === '/demograph') {
                    window.location.href = '/demograph';
                  }
                }}
              >
                <SidebarIcon type={feature} />
                <span style={!subMenuSelected ? {} : getSpanStyle(sidebarColor)}>
                  {transformFeatureName(feature)}
                </span>
              </Link>
            </Item>
          )}
        </React.Fragment>
      );
    });
};

const renderCollapsedMenu = (
  divisions,
  features,
  rootPath,
  collapsed,
  subMenuSelected,
  setSubMenuSelected,
  sidebarColor,
  isSelfService,
  billing,
  orgLevel,
  parentOrgLevel,
  urlLink,
  // Preview-aware billing for the Usage sub-route (see accessibleFeatures)
  usageBilling = billing
) => {
  return (
    <ItemGroup key={'collapsedMenu'}>
      {divisions.map((division, i) => {
        if (division === 'ATTENTION SIGNALS') {
          const hasPermission = features.includes('EDITORIAL');
          if (!hasPermission) return null;
          return accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing,
            usageBilling
          );
        } else if (division === 'LIBRARY') {
          if (!isSelfService) return null;
          return accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            parentOrgLevel,
            urlLink,
            billing,
            usageBilling
          );
        } else if (division === 'TASK MANAGEMENT') {
          const hasPermission = features.includes('TASK_MANAGEMENT');
          if (!hasPermission) return null;
          return accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel
          );
        } else if (division === 'ADMIN') {
          let subDiv = subDivisions[division];

          const hasPermission = features.includes('ORGS');
          const hasSystemAlertsPermission = features.includes('SYSTEM_ALERTS');
          const hasApiAccessPermission = features.includes('API_ACCESS');

          if (!hasPermission) {
            if (
              (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
              orgLevel === 'CHANNEL_PARTNER'
            ) {
              subDiv = ['KNOWLEDGE_BASE', 'SETTINGS'];
            } else {
              subDiv = ['SETTINGS'];
            }
          } else {
            if (
              (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
              orgLevel === 'CHANNEL_PARTNER'
            ) {
              subDiv = ['KNOWLEDGE_BASE', 'SETTINGS', 'ORGS'];
            } else {
              subDiv = ['SETTINGS', 'ORGS'];
            }
          }

          // Add SYSTEM_ALERTS if user has permission
          if (hasSystemAlertsPermission && !subDiv.includes('SYSTEM_ALERTS')) {
            subDiv.push('SYSTEM_ALERTS');
          }

          // Add API_DOCS if user has API_ACCESS permission
          if (hasApiAccessPermission && !subDiv.includes('API_DOCS')) {
            subDiv.push('API_DOCS');
          }

          // SETTINGS is available to every user, so the ADMIN group always renders.
          return accessibleFeatures(
            subDiv,
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing,
            usageBilling
          );
        } else {
          return accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            false,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing,
            usageBilling
          );
        }
      })}
    </ItemGroup>
  );
};

const renderExtendedMenu = (
  divisions,
  features,
  rootPath,
  collapsed,
  subMenuSelected,
  setSubMenuSelected,
  sidebarColor,
  isSelfService,
  billing,
  orgLevel,
  parentOrgLevel,
  urlLink,
  // Preview-aware billing for the Usage sub-route (see accessibleFeatures)
  usageBilling = billing
) => {
  return divisions.map((division, i) => {
    if (division === 'ATTENTION SIGNALS') {
      const hasPermission = features.includes('EDITORIAL');
      if (!hasPermission) return null;
      return (
        <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
          {accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing,
            usageBilling
          )}
        </ItemGroup>
      );
    }

    if (division === 'LIBRARY') {
      if (!isSelfService) return null;
      return (
        <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
          {accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            parentOrgLevel,
            urlLink,
            billing,
            usageBilling
          )}
        </ItemGroup>
      );
    }

    if (division === 'TASK MANAGEMENT') {
      const hasPermission = features.includes('TASK_MANAGEMENT');
      if (!hasPermission) return null;
      return (
        <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
          {accessibleFeatures(
            subDivisions[division],
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel
          )}
        </ItemGroup>
      );
    }

    if (division === 'ADMIN') {
      let subDiv = subDivisions[division];

      const hasPermission = features.includes('ORGS');
      const hasSystemAlertsPermission = features.includes('SYSTEM_ALERTS');
      const hasApiAccessPermission = features.includes('API_ACCESS');

      if (!hasPermission) {
        if (
          (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
          orgLevel === 'CHANNEL_PARTNER'
        ) {
          subDiv = ['KNOWLEDGE_BASE', 'SETTINGS'];
        } else {
          subDiv = ['SETTINGS'];
        }
      } else {
        if (
          (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
          orgLevel === 'CHANNEL_PARTNER'
        ) {
          subDiv = ['KNOWLEDGE_BASE', 'SETTINGS', 'ORGS'];
        } else {
          subDiv = ['SETTINGS', 'ORGS'];
        }
      }

      // Add SYSTEM_ALERTS if user has permission
      if (hasSystemAlertsPermission && !subDiv.includes('SYSTEM_ALERTS')) {
        subDiv.push('SYSTEM_ALERTS');
      }

      // Add API_DOCS if user has API_ACCESS permission
      if (hasApiAccessPermission && !subDiv.includes('API_DOCS')) {
        subDiv.push('API_DOCS');
      }

      // SETTINGS is available to every user, so the ADMIN group always renders.
      return (
        <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
          {accessibleFeatures(
            subDiv,
            features,
            rootPath,
            collapsed,
            subMenuSelected,
            setSubMenuSelected,
            sidebarColor,
            true,
            orgLevel,
            urlLink,
            parentOrgLevel,
            billing,
            usageBilling
          )}
        </ItemGroup>
      );
    }

    return division === 'MAIN' ? (
      <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
        {accessibleFeatures(
          subDivisions[division],
          features,
          rootPath,
          collapsed,
          subMenuSelected,
          setSubMenuSelected,
          sidebarColor,
          false,
          orgLevel,
          urlLink,
          parentOrgLevel,
          billing,
          usageBilling
        )}
      </ItemGroup>
    ) : shouldShowSubCategory(features, subDivisions[division]) ? (
      <ItemGroup key={division} title={division} style={{ width: '100%', marginBottom: '10%' }}>
        {accessibleFeatures(
          subDivisions[division],
          features,
          rootPath,
          collapsed,
          subMenuSelected,
          setSubMenuSelected,
          false,
          orgLevel,
          urlLink,
          parentOrgLevel,
          billing,
          usageBilling
        )}
      </ItemGroup>
    ) : (
      ''
    );
  });
};

// We are assuming that we always want to show at least the "MAIN" subcategory
const renderSubCategoriesAndFeatures = (
  divisions,
  features,
  rootPath,
  collapsed,
  subMenuSelected,
  setSubMenuSelected,
  sidebarColor,
  isSelfService,
  billing,
  orgLevel,
  urlLink,
  parentOrgLevel,
  // Preview-aware billing for the Usage sub-route (see accessibleFeatures)
  usageBilling = billing
) => {
  return false
    ? renderCollapsedMenu(
        divisions,
        features,
        rootPath,
        collapsed,
        subMenuSelected,
        setSubMenuSelected,
        sidebarColor,
        isSelfService,
        billing,
        orgLevel,
        urlLink,
        parentOrgLevel,
        usageBilling
      )
    : renderExtendedMenu(
        divisions,
        features,
        rootPath,
        collapsed,
        subMenuSelected,
        setSubMenuSelected,
        sidebarColor,
        isSelfService,
        billing,
        orgLevel,
        urlLink,
        parentOrgLevel,
        usageBilling
      );
};

const Sidebar = (props) => {
  const userPermission = determineUserAccess(props.currentUser.permission);
  const orgLevel = props.currentUser.role.org.level;
  // Preview-aware billing for the Usage sub-route: work-as-parent uses the
  // REAL user's billing flag; faithful preview and normal sessions keep
  // currentUser.permission (the org's own flags).
  const usageBilling = determineUserAccess(
    getEffectivePermission(props.currentUser)
  ).billing;

  let urlLink;
  let parentOrgLevel = null;
  let parentOrg = props.currentUser.role.org.parentOrg;

  if (parentOrg.length) {
    urlLink = parentOrg[parentOrg.length - 1].advertiserKnowledgeBaseURL;
    parentOrgLevel = parentOrg[parentOrg.length - 1].level;
  }

  const { isSelfService, billing } = userPermission;

  const { collapsed } = props.state;
  const [subMenuSelected, setSubMenuSelected] = useState(false);
  const [logoKey, setLogoKey] = useState(props.logo ? props.logo.key : null);
  const [defaultLogoKey, setDefaultLogoKey] = useState(props.logo ? props.logo.key : null);
  const { features, location, toggleSideBar } = props;

  // Mobile breakpoint detection
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const rootPath = location.pathname.split('/')[1].toUpperCase();
  
  const getSelectedKey = () => {
    const pathname = location.pathname;
    if (pathname.startsWith('/tasks/projects')) return 'PROJECTS';
    if (pathname.startsWith('/tasks/analytics')) return 'TASK_ANALYTICS';
    // /tasks/form (edit full page) highlights Tasks — the Create Task menu item is gone
    if (pathname.startsWith('/tasks')) return 'TASKS';
    return rootPath;
  };

  const divisions = Object.keys(subDivisions);
  const params = new URLSearchParams(props.location.search);
  let sidebarColor;
  //Listen for changes on local storage to update the logo on the sidebar
  window.addEventListener('imageKey', () => {
    const tempImage = localStorage.getItem('imageKey');
    if (tempImage) {
      setLogoKey(tempImage);
      localStorage.removeItem('imageKey');
    }
  });
  useEffect(() => {
    //Update logo key if the logo changes. This usually happens during preview advertiser
    if (props.logo && defaultLogoKey !== props.logo.key) {
      setDefaultLogoKey(props.logo.key);
      setLogoKey(props.logo.key);
    } else if (!props.logo && defaultLogoKey !== null) {
      //Consider the case where the org has no logo.
      setDefaultLogoKey(null);
      setLogoKey(null);
    }
  }, [defaultLogoKey, props.logo]);

  // Handle window resize for responsive breakpoints
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let sidebarIsGradient = false;
  let sidebarGradientStart = '#00baff';
  let sidebarGradientEnd = '#7240e9';

  if (props && props.themeData && props.themeData.getOrgThemeConfig) {
    sidebarColor = props.themeData.getOrgThemeConfig.sidebarColor;
    sidebarIsGradient = props.themeData.getOrgThemeConfig.sidebarIsGradient || false;
    sidebarGradientStart = props.themeData.getOrgThemeConfig.sidebarGradientStart || '#00baff';
    sidebarGradientEnd = props.themeData.getOrgThemeConfig.sidebarGradientEnd || '#7240e9';
  }

  // Build the background style - use gradient if enabled, otherwise solid color
  const sidebarBackground = sidebarIsGradient
    ? `linear-gradient(180deg, ${sidebarGradientStart} 0%, ${sidebarGradientEnd} 100%)`
    : sidebarColor || '#001529';

  if (params.get('showNewSegments') === 'true') {
    window.localStorage.setItem('showNewSegments', true);
  }

  if (params.get('showNewSegments') === 'false') {
    window.localStorage.removeItem('showNewSegments');
  }

  if (props.horizontalNavigation) {
    // Build menu item for a single feature
    const buildFeatureMenuItem = (feature) => {
      const keySubRoutes = Object.keys(subRoutes).find((key) => key === feature);

      // Skip certain features
      if (feature === 'LIBRARY' || feature === 'HOME' || feature === 'USERS') {
        return null;
      }

      if (keySubRoutes) {
        // Feature has sub-routes - create nested SubMenu
        const subRouteItems = subRoutes[keySubRoutes]
          .filter((subRoute) => !(subRoute === 'Usage' && !usageBilling))
          .map((subRoute) => {
            const sitemapSubRouteIndex = Object.values(sitemap).findIndex(
              (sitemapValues) => sitemapValues === subRoute
            );
            const subRouteURL = Object.keys(sitemap)[sitemapSubRouteIndex];
            return (
              <Menu.Item key={subRoute}>
                <Link to={subRouteURL || '/home'}>{subRoute}</Link>
              </Menu.Item>
            );
          });

        return (
          <Menu.SubMenu
            key={`feature-${feature}`}
            popupClassName="sidebar-gradient-submenu"
            popupStyle={{
              background: sidebarBackground,
              backgroundColor: sidebarIsGradient ? 'transparent' : sidebarColor,
            }}
            title={
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <SidebarIcon type={feature} />
                <span>{transformFeatureName(feature)}</span>
              </span>
            }
          >
            {subRouteItems}
          </Menu.SubMenu>
        );
      } else {
        // Leaf feature - simple menu item
        return (
          <Menu.Item key={feature}>
            <Link to={transformURL(undefined, feature)}>
              <SidebarIcon type={feature} />
              <span style={{ marginLeft: '8px' }}>{transformFeatureName(feature)}</span>
            </Link>
          </Menu.Item>
        );
      }
    };

    // Build division dropdown with all its features
    const buildDivisionMenu = (division) => {
      let featuresToShow;
      if (division === 'ADMIN') {
        featuresToShow = getAdminSubDiv();
      } else if (division === 'MAIN') {
        // MAIN always renders as a division, so gate its children on feature access (MD-11242)
        featuresToShow = getVisibleMainFeatures(subDivisions[division], features);
      } else {
        featuresToShow = subDivisions[division];
      }

      const featureMenuItems = featuresToShow
        .map((feature) => buildFeatureMenuItem(feature))
        .filter((item) => item !== null);

      if (featureMenuItems.length === 0) return null;

      // Create dropdown menu with features
      const dropdownMenu = (
        <Menu theme="dark" style={{ background: sidebarBackground, borderRadius: '4px' }}>
          {featureMenuItems}
        </Menu>
      );

      return (
        <Dropdown
          key={`division-${division}`}
          overlay={dropdownMenu}
          trigger={['hover']}
          placement="bottomCenter"
          overlayClassName="division-dropdown-overlay"
        >
          <div
            style={{
              cursor: 'pointer',
              padding: '0 12px',
              color: 'rgba(255, 255, 255, 0.85)',
              display: 'flex',
              alignItems: 'center',
              height: '46px',
              userSelect: 'none',
            }}
          >
            {division}
          </div>
        </Dropdown>
      );
    };

    // Get divisions to render based on permissions
    const getDivisionsToRender = () => {
      const divisionsToRender = [];
      const divisionOrder = ['MAIN', 'ATTENTION SIGNALS', 'LIBRARY', 'TASK MANAGEMENT', 'ADMIN'];

      divisionOrder.forEach((division) => {
        // Skip divisions based on permission checks
        if (division === 'ATTENTION SIGNALS' && !features.includes('EDITORIAL')) {
          return;
        }
        if (division === 'LIBRARY' && !isSelfService) {
          return;
        }
        if (division === 'TASK MANAGEMENT' && !features.includes('TASK_MANAGEMENT')) {
          return;
        }
        // MAIN and ADMIN always render
        divisionsToRender.push(division);
      });

      return divisionsToRender;
    };

    // Get admin sub-features
    const getAdminSubDiv = () => {
      let subDiv = subDivisions['ADMIN'];
      const hasOrgPermission = features.includes('ORGS');
      const hasSystemAlertsPermission = features.includes('SYSTEM_ALERTS');
      const hasApiAccessPermission = features.includes('API_ACCESS');

      if (!hasOrgPermission) {
        if (
          (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
          orgLevel === 'CHANNEL_PARTNER'
        ) {
          subDiv = ['KNOWLEDGE_BASE', 'SETTINGS'];
        } else {
          subDiv = ['SETTINGS'];
        }
      } else {
        if (
          (orgLevel === 'STANDARD' && urlLink && parentOrgLevel === 'CHANNEL_PARTNER') ||
          orgLevel === 'CHANNEL_PARTNER'
        ) {
          subDiv = ['KNOWLEDGE_BASE', 'SETTINGS', 'ORGS'];
        } else {
          subDiv = ['SETTINGS', 'ORGS'];
        }
      }

      // Add SYSTEM_ALERTS if user has permission
      if (hasSystemAlertsPermission && !subDiv.includes('SYSTEM_ALERTS')) {
        subDiv.push('SYSTEM_ALERTS');
      }

      // Add API_DOCS if user has API_ACCESS permission
      if (hasApiAccessPermission && !subDiv.includes('API_DOCS')) {
        subDiv.push('API_DOCS');
      }

      return subDiv;
    };

    if (isMobile) return null;

    return (
      <div
        style={{
          background: sidebarIsGradient
            ? `linear-gradient(90deg, ${sidebarGradientStart} 0%, ${sidebarGradientEnd} 100%)`
            : sidebarBackground,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px',
          minHeight: '59px',
          flexWrap: 'wrap',
          position: 'relative',
          zIndex: 99,
        }}
      >
        {/* Logo thumbnail on the left */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginRight: '16px',
            height: '43px',
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          <OrgDisplay imgKey={logoKey ? logoKey : null} collapsed={true} />
        </div>

        {/* Navigation container with HOME and division dropdowns */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flex: 1,
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* HOME Link */}
          <Link
            to={'/home'}
            style={{
              cursor: 'pointer',
              padding: '0 12px',
              color: 'rgba(255, 255, 255, 0.85)',
              display: 'flex',
              alignItems: 'center',
              height: '46px',
              textDecoration: 'none',
              fontSize: '14px',
            }}
          >
            HOME
          </Link>

          {/* Render divisions as dropdowns */}
          {getDivisionsToRender()
            .map((division) => buildDivisionMenu(division))
            .filter((item) => item !== null)}
        </div>
      </div>
    );
  }

  return (
    <>
      {!isMobile && (
        <Sider
          collapsible
          trigger={null}
          breakpoint="xl"
          collapsedWidth="80"
          collapsed={collapsed}
          onBreakpoint={(broken) => {
            toggleSideBar(broken);
          }}
          style={{
            position: 'sticky',
            top: 0,
            left: 0,
            height: '100vh',
            overflow: 'auto',
            backgroundImage: sidebarIsGradient ? sidebarBackground : 'none',
            backgroundColor: sidebarIsGradient ? 'transparent' : sidebarBackground,
            backgroundAttachment: 'fixed',
            backgroundSize: '100% 100vh',
          }}
        >
          <div className={collapsed ? 'custom-sidebar-color collapsed' : 'custom-sidebar-color'}>
            {/* {isSelfService === true && (
              <>
                {props.chatWootLoading === false && (
                  <ChatwootWidget
                    chatWootId={props.chatWootId}
                    currentUser={props.currentUser}
                  />
                )}
              </>
            )} */}
            <div style={collapsed ? null : logo}>
              <OrgDisplay imgKey={logoKey ? logoKey : null} collapsed={collapsed} />
            </div>
            <div>
              <Menu
                theme="dark"
                mode="inline"
                selectedKeys={[getSelectedKey()]}
                style={{
                  border: 'none',
                  marginBottom: '30px',
                }}
              >
                {renderSubCategoriesAndFeatures(
                  divisions,
                  features,
                  rootPath,
                  collapsed,
                  subMenuSelected,
                  setSubMenuSelected,
                  sidebarColor,
                  isSelfService,
                  billing,
                  orgLevel,
                  parentOrgLevel,
                  urlLink,
                  usageBilling
                )}
              </Menu>
            </div>
          </div>
        </Sider>
      )}
    </>
  );
};

export default withRouter(Sidebar);
